module.exports = __webpack_public_path__ + "img/h5_screenshot_classic.c4dd83c0.jpg";